import { render, staticRenderFns } from "./informationSupplement.vue?vue&type=template&id=222bbf88&scoped=true"
import script from "./informationSupplement.vue?vue&type=script&lang=js"
export * from "./informationSupplement.vue?vue&type=script&lang=js"
import style0 from "./informationSupplement.vue?vue&type=style&index=0&id=222bbf88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222bbf88",
  null
  
)

export default component.exports